import { useState, useEffect } from "react";
import Offer from "../../../../APIController/Offer";
import { useModal } from "../../../../Components/Modal";
import Text from "../../../../Components/Text";
import CrudPage from "../../../../Components/CrudPage";
import OfferForm from "../Forms/OfferForm";
import { generateOfferCardsPDF } from "../../../../Helper/OfferPDFGenerator";
import WorkspaceSelector from "../../../../Helper/WorkspaceSelector";

function OfferManagement() {
    const { getAllOffers, disableOffers } = Offer()
    const { getCurrency } = WorkspaceSelector()

    /* Modal Loader */
    const { ModalView, openModal, closeModal } = useModal()
    const [offers, setOffers] = useState([])


    useEffect(() => {
        fetchOfferData()
    }, [])

    const fetchOfferData = async () => {
        const data = await getAllOffers()
        setOffers(data)
    }

    const formActions = () => {
        fetchOfferData()
        closeModal()
    }

    /* Add Button Click helper */
    const handleAddClick = (e) => {
        e.preventDefault();
        openModal(<OfferForm afterAction={() => formActions()} />)
    }

    const handleDeleteClick = async (e, offer) => {
        await disableOffers(offer.offerCode)
        fetchOfferData()
    }

    /* Print all codes as PDF */
    const handlePrintAllCodes = async () => {
        if (offers.length === 0) {
            alert("Keine Coupons zum Drucken vorhanden")
            return
        }

        await generateOfferCardsPDF(offers, getCurrency())
    }

    /* rendering view */
    const MainView = () => (
        <>
            <CrudPage
                title={"Coupons"}
                items={offers}
                crudActions={[
                    { type: "delete", color: "red", action: handleDeleteClick, icon: "trash" },
                    { type: "custom", color: "bg-blue-500", action: handlePrintAllCodes, tIconName: "printer", text: "Drucke alle Codes" },
                    { type: "create", color: "bg-white", action: handleAddClick }]}
                displayMethod={(offer) => {
                    return (
                        <>
                            <Text type="itemtext">{offer.offerCode}</Text>
                            {offer.offerSnapshotProducts && offer.offerSnapshotProducts.map((offerProduct, index) => {
                                return (
                                    <Text key={index} type="itemtext">
                                        {offerProduct.count}x {offerProduct?.name || 'Unbekannt'}
                                    </Text>
                                )
                            })}
                            <Text type="itemtext" className="font-bold">{offer.offerPrice} {getCurrency()}</Text>
                        </>
                    )
                }}
                allowedTarget="createCoupons"
                currentTargetValue={true}
            />
            <ModalView />
        </>
    )

    return (MainView())
}

export default OfferManagement